module.exports = __webpack_public_path__ + "static/media/25_A.0cabf917.png";